import { Component, Input, OnInit } from '@angular/core';
import { FilterOption } from 'src/app/library/enums/filters/filter-option.enum';

@Component({
    selector: 'app-search-empty-state',
    templateUrl: './search-empty-state.component.html',
    styleUrls: ['./search-empty-state.component.scss']
})
export class SearchEmptyStateComponent implements OnInit {
    @Input() filterOption: FilterOption;
    @Input() emptyResult: boolean;
    @Input() dialogOption: boolean;

    public readonly filterOptionEnum = FilterOption;

    constructor() {}

    ngOnInit() {}
}
